@if (searchMessage.message) {
  <div class="pb-5">
    <p class="text-sm" [innerHTML]="searchMessage.message | linkify"></p>
  </div>
}
@if (searchMessage.searchResultItems && searchMessage.searchResultItems.length>0) {
  <div class="table-container text-sm">
    <p-table [resizableColumns]="true" columnResizeMode="expand"  [value]="searchMessage.searchResultItems">
      <ng-template #header>
        <tr>
          @if (isAvailableDocumentNo) {
            <th pResizableColumn>{{ 'searchResult.headers.documentNumber' | translate }}</th>
          }
          @if (isAvailableArticleNo) {
            <th pResizableColumn>{{ 'searchResult.headers.articleNo' | translate }}</th>
          }
          @if (isAvailableArticleDescription) {
            <th pResizableColumn>{{ 'searchResult.headers.description' | translate }}</th>
          }
          @if (isAvailableValueNet) {
            <th pResizableColumn class="text-end">{{ 'searchResult.headers.valueNet' | translate }}</th>
          }
          @if (isAvailableValueGross) {
            <th pResizableColumn class="text-end">{{ 'searchResult.headers.valueGross' | translate }}</th>
          }
        </tr>
      </ng-template>
      <ng-template #body let-searchItem>
        <tr class="hover:bg-gray-100 dark:hover:bg-gray-900 cursor-pointer" (click)="openDocument(searchItem.documentNo, searchItem.documentType)">
          @if (isAvailableDocumentNo) {
            <td>
              <span class="p-column-title">{{ "searchResult.headers.documentNumber" | translate }}</span>
              <span>{{ searchItem.documentNo}}</span>
            </td>
          }
          @if (isAvailableArticleNo) {
            <td>
              <span class="p-column-title">{{ "searchResult.headers.articleNo" | translate }}</span>
              <span class="truncate hover:text-clip w-full" [title]="searchItem.articleNo">{{ searchItem.articleNo }}</span>
            </td>
          }
          @if (isAvailableArticleDescription) {
            <td>
              <span class="p-column-title">{{ "searchResult.headers.description" | translate }}</span>
              <span class="truncate hover:text-clip w-full" [title]="searchItem.articleDescription">{{ searchItem.articleDescription }}</span>
            </td>
          }
          @if (isAvailableValueNet) {
            <td class="text-end">
              <span class="p-column-title">{{ "searchResult.headers.valueNet" | translate }}</span>
              <span>{{ searchItem.valueNet | currency:(searchItem.documentCurrency ? searchItem.documentCurrency : 'EUR'):'symbol':'1.2-2':locale() }}</span>
            </td>
          }
          @if (isAvailableValueGross) {
            <td class="text-end">
              <span class="p-column-title">{{ "searchResult.headers.valueGross" | translate }}</span>
              <span>{{ searchItem.valueGross | currency:(searchItem.documentCurrency ? searchItem.documentCurrency : 'EUR'):'symbol':'1.2-2':locale() }}</span>
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>
}
